import React from 'react';
import ProcSection from './ProcSection';
import { agentQuotes } from './shipmentAgentHelpers';
import { formatDecimal } from '../../utils/decimal';
import { SHIPMENT_MODE_LABELS } from './procurementLabels';
import type { ShippingAgent } from '../../types/Procurement';

interface Props {
  agents: ShippingAgent[];
  cbm: string | null;
  kg: string | null;
  /** The agent already on the shipment, marked in the list. */
  selectedId: string;
}

/** Every active agent's price for this shipment's size, in the agent's own currency. Rates are never converted between currencies. */
const ShippingAgentComparison: React.FC<Props> = ({ agents, cbm, kg, selectedId }) => {
  const quotes = agentQuotes(agents, { cbm, kg });
  if (quotes.length === 0) return null;
  return (
    <ProcSection title="Compare shipping agents" ariaLabel="Compare shipping agents">
      <div className="proc-scroll">
        <table className="proc-table">
          <thead><tr><th>Agent</th><th>Mode</th><th className="proc-num">Rate</th><th className="proc-num">Price for this shipment</th></tr></thead>
          <tbody>
            {quotes.map(q => (
              <tr key={q.agent.id}>
                <td>{q.agent.name}{q.agent.id === selectedId ? ' (selected)' : ''}</td>
                <td>{SHIPMENT_MODE_LABELS[q.agent.shipping_mode] ?? q.agent.shipping_mode}</td>
                <td className="proc-num">{q.rate ? `${formatDecimal(q.rate, q.currency)} / ${q.unit}` : 'No rate set'}</td>
                <td className="proc-num">{q.amount ? formatDecimal(q.amount, q.currency) : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ProcSection>
  );
};

export default ShippingAgentComparison;
